import { T0, media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledFormPageTitle = styled(T0)`
    margin-bottom:36px;
    text-align: center;
    text-transform: uppercase;
    line-height: 1.2;
    font-size: 32px;

    ${media.sm`
        font-size: 35px;
    `}
`;
